/* Common config items */
const config = {
  basename: process.env.REACT_APP_BASENAME,
  appVersion: process.env.REACT_APP_VERSION,
  staticAssets: process.env.REACT_APP_STATIC_ASSETS || '',
  recaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
}

export default config